import React, { useState, useEffect, Fragment } from "react";
import Layout from "components/sales/layout/layout";
import Images from "assets/images/imageData";
import localization from "assets/localization/localization";
import DocumentView from "components/sales/downloadDocView/documentView";
import RepliesOnTicket from "components/tickets/repliesOnTicket";
import DivLayout from "components/sales/divLayout/divLayout";
import ReplyForm from "components/tickets/formSection/replyForm/replyForm";
import PanelCardWithHeading from "components/tickets/panelCardWithHeading";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import { Button } from "react-bootstrap";
import ModalPop from "components/sales/modal/modal";
import './ticketDetails.css';


const TicketDetails = ({
  match,
  getTicketDetails,
  ticketDetails,
  documentUploadUrl,
  documentUrlData,
  repliesOnTicket,
  changeStatus,
  getStatusList,
  statusList = [],
}) => {
  const [ticketData, setTicketData] = useState(null);
  const [ticketId, setTicketId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isFiled, setIsFiled] = useState(false);
  const [newStatus, setNewStatus] = useState();
  const [isStatusSuccess, setIsStatusSuccess] = useState(false);
  const [isStatusModal, setIsStatusModal] = useState(false);

  const headerBtns = () => {
    return (
      <Button
        onClick={() => setIsStatusModal(true)}
        className="btn btn-transparent"
      >
        {" "}
        {localization.changeStatus}
      </Button>
    );
  };

  useEffect(() => {
    setTicketId(match.params.id);
  }, [match.params.id]);

  useEffect(() => {
    if (getTicketDetails !== null && ticketId)
      (async () => {
        setIsLoading(true);
        await getTicketDetails(ticketId);
        setIsLoading(false);
        await getStatusList();
      })();
  }, [getTicketDetails, ticketId]);

  useEffect(() => {
    if (ticketDetails) {
      setTicketData(ticketDetails);
      setNewStatus(ticketDetails.status);
    }
  }, [ticketDetails]);

  const replySubmit = async (replyObject) => {
    if (!replyObject.responseText) {
      setIsFiled(true);
    } else {
      setIsFiled(false);
      setIsLoading(true);
      await repliesOnTicket(replyObject);
      await getTicketDetails(ticketId);
      setIsLoading(false);
    }
  };

  const onSubmitStatus = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    await changeStatus(ticketId, newStatus);
    await getTicketDetails(ticketId);
    setIsLoading(false);
    setIsStatusModal(false);
    setIsStatusSuccess(true);
  };

  const successIconBox = (text, func) => {
    return (
      <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>{text}</h5>
        <div classname="statusbtn">
        <Button onClick={func} className="btn btn-primary">
          {localization.continue} <img src={Images?.ArrowRight} alt="" />
        </Button>
        </div>
      </div>
    );
  };

  const statusSuccessClose = () => setIsStatusSuccess(false);

  return (
    <Layout
      title={localization.ticketDetails}
      Buttons={headerBtns}
      isGoback
      isLoading={isLoading}
      className={isFiled ? "requiredFileds" : ""}
    >
      {ticketData !== null && (
        <Fragment>
          <PanelCardWithHeading title={localization.ticketDetails}>
            <div className="details-listing">
              <DivLayout heading={localization.ticketId} data={ticketData.id} />
              <DivLayout
                heading={localization.createdOn}
                data={ticketData.createdDate.slice(0, 10)}
              />
              <DivLayout
                heading={localization.status}
                data={ticketData.status}
                status
              />
              <DivLayout
                heading={localization.raisedTo}
                data={ticketData.raised_to}
              />
              <DivLayout
                heading={localization.subject}
                data={ticketData.subject}
              />
              <DivLayout
                heading={localization.summary}
                data={ticketData.summary}
              />
              {/* {ticketData.document && (
                <DocumentView attachment={JSON.parse(ticketData.document)} />
              )} */}
               {ticketData.document && (ticketData.document.map((document) => (
                <DocumentView attachment={document} />
                )))}
            
            </div>
          </PanelCardWithHeading>

          <PanelCardWithHeading title={localization.replies}>
            <ReplyForm
              ticketId={ticketId}
              replySubmit={replySubmit}
              documentUploadUrl={documentUploadUrl}
              documentUrlData={documentUrlData}
            />

            <RepliesOnTicket repliesData={ticketData.replies || []} />
          </PanelCardWithHeading>

          <ModalPop
            title={localization.changeStatus}
            show={isStatusModal}
            handleModalHide={() => setIsStatusModal(false)}
          >
            <div className="text-center">
              <h5>{localization.pleaseConfirmTheStatusOfThisTicket}</h5>
              <form onSubmit={(e) => onSubmitStatus(e)}>
                <DropDownInput
                  disabled={statusList.length === 0}
                  // value={newStatus}
                  label={localization.status}
                  data={statusList}
                  getIdValue={(val) => setNewStatus(val)}
                />
                <div className="form-group" >
                  <button type="submit" className="btn btn-primary">
                    {localization.continue}
                    <img src={Images?.ArrowRight} alt="" />
                  </button>
                </div>
              </form>
            </div>
          </ModalPop>
          
          <ModalPop
            title={localization.rejectSuccessfully}
            show={isStatusSuccess}
            handleModalHide={statusSuccessClose}
          >
            
            {successIconBox(
              localization.statusupdatedsuccessfully,
              statusSuccessClose
            )}
          </ModalPop>
       
        </Fragment>
      )}
    </Layout>
  );
};

export default TicketDetails;
